// @flow

import * as React from 'react';
import './App.css';
import 'antd/dist/antd.css';
import {
  HashRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import type {Match} from 'react-router';
import Heroes from './pages/heroes';
import TeamOptimizer from './pages/team_optimizer';
import Analytics from 'react-router-ga';
import MainContainer from './components/main_container';
import {Redirect} from 'react-router';
import Helmet from 'react-helmet';
import qs from "query-string";

const defaultTitle = 'Guardian Tales Database';
const defaultDescription =
  'Game database and team optimization tools for Guardian Tales';

function App(): React.Node {
  return (
    <Router>
      <div className="App">
        <MainContainer>
          <Analytics
            id="UA-175529571-1"
            debug={process.env.NODE_ENV === 'development'}
          >
            <Switch>
              <Route
                path="/heroes/:hero_name?"
                render={({match}: { match: Match }) => {
                  const heroName = match.params.hero_name ?? 'Heroes';
                  const title = (heroName ?? 'Heroes') + ' | ' + defaultTitle;
                  const description = heroName != null ?
                    'Profile of ' + heroName :
                    defaultDescription;
                  return <>
                    <Helmet>
                      <title>{title}</title>
                      <meta name="description" content={description}/>
                    </Helmet>
                    <Heroes/>
                  </>;
                }}>
              </Route>
              <Route
                path="/teams"
                render={({location}: { location: Location }) => {
                  const params = qs.parse(location.search);
                  const heroNames = params.selected_heroes
                  let title = 'Team Optimizer | ' + defaultTitle;
                  if (heroNames != null && heroNames !== '') {
                    title = heroNames.split(',').join(' - ')
                      + ' | ' + title;
                  }
                  const description = 'Find the optimized teams for you.';
                  return <>
                    <Helmet>
                      <title>{title}</title>
                      <meta name="description" content={description}/>
                    </Helmet>
                    <TeamOptimizer/>
                  </>;
                }}>
              </Route>
              <Route path="/">
                <Redirect to="/heroes"/>
              </Route>
            </Switch>
          </Analytics>
        </MainContainer>
      </div>
    </Router>
  );
}

export default App;
